import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface PackagingSlip {
    packagingSlipId: string;
    packagingSlipDate: string;
    poLinesShippedWithQuantity: PoLinesShippedWithQuantity[];
}

export interface PoLinesShippedWithQuantity {
    key: string;
    value: string;
}

export interface PackagingSlipsParameter extends ApiParameter {
    orderId: string;
}

export const url = "/api/v2/packagingslips/";

export async function getPackagingSlips(parameter: PackagingSlipsParameter) {
    try {
        const result = await get<PackagingSlip[]>(`${url}${parameter.orderId}`);
        return result;
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

const cacheKey = "orderPackagingSlips";

const setInLocalStorage = (pSlipsWithOrderId: Record<string, PackagingSlip[]>) => {
    window.localStorage.setItem(cacheKey, JSON.stringify(pSlipsWithOrderId));
};

export function getLocalPackagingSlips(): Record<string, PackagingSlip[]> {
    return JSON.parse(window.localStorage.getItem(cacheKey) || "{}") as Record<string, PackagingSlip[]>;
}

export function getLocalPackagingSlipsForId(orderId: string): PackagingSlip[] | undefined {
    const packagingSlipsById = getLocalPackagingSlips();
    return packagingSlipsById[orderId];
}

export function addPackagingSlipsToStorage(orderId: string, packagingSlips: PackagingSlip[]): boolean {
    const localPackagingSlips = getLocalPackagingSlips();
    if (!localPackagingSlips[orderId]) {
        const newSlipsList =
            Object.keys(localPackagingSlips).length === 5
                ? Object.keys(localPackagingSlips)
                      .filter((_, index) => index !== 0)
                      .reduce<Record<string, PackagingSlip[]>>((acc, key) => {
                          acc[key] = localPackagingSlips[key];
                          return acc;
                      }, {})
                : localPackagingSlips;
        newSlipsList[orderId] = packagingSlips;
        setInLocalStorage(newSlipsList);
        return true;
    }
    return false;
}

export function removePackagingSlipFromLocal(orderId: string): boolean {
    const localPackagingSlips = getLocalPackagingSlips();
    if (localPackagingSlips[orderId]) {
        delete localPackagingSlips[orderId];
        setInLocalStorage(localPackagingSlips);
        return true;
    }
    return false;
}

export function removeAllProducts(): void {
    setInLocalStorage({});
}
